import React, { PropsWithChildren } from 'react';

import { classNames } from '@/helpers/classNames';

import styles from './Flex.module.scss';

type FlexProps = {
	className?: string;
	justifyContent?: React.CSSProperties['justifyContent'];
	alignItems?: React.CSSProperties['alignItems'];
	flexDirection?: React.CSSProperties['flexDirection'];
	flexWrap?: React.CSSProperties['flexWrap'];
	flex?: React.CSSProperties['flex'];
	flexGrow?: React.CSSProperties['flexGrow'];
	flexShrink?: React.CSSProperties['flexShrink'];
	flexBasis?: React.CSSProperties['flexBasis'];
	alignContent?: React.CSSProperties['alignContent'];
	alignSelf?: React.CSSProperties['alignSelf'];
	gap?: React.CSSProperties['gap'];
	fullWidth?: boolean;
	style?: React.CSSProperties;
};

export const Flex: React.FC<PropsWithChildren<FlexProps>> = ({
	className,
	children,
	style,
	fullWidth,
	...flexProps
}) => {
	const classes = classNames([
		styles['root'],
		className,
		fullWidth && 'w-100',
	]);

	return (
		<div className={classes} style={{ ...flexProps, ...style }}>
			{children}
		</div>
	);
};
